import _ from 'lodash';

const QUERY_TO_KEEP = [
  'disableHeader',
  'disableEqualWeb',
  'disableHandtalk',
  'disableToastNotification',

  // PlataformaA mobile params used for tracking
  'X-Client-Type',
  'X-Device-Id'
];

export default ({ redirect, route, from }) => {
  if (!from) { // SSR has no "from" route
    return;
  }
  // Use the query strings from the previous route, but replace them if they're from the new navigation
  const query = Object.assign({}, _.pick(from.query, QUERY_TO_KEEP), route.query);

  // Prevent infinite redirects
  if (_.isEqual(query, route.query)) {
    return;
  }

  redirect({
    path: route.path,
    query
  });
};
